






import { Component, Prop } from 'vue-property-decorator'
import ViewBase from '@/utils/ViewBase'
import { MapType } from '@/utils/types'

@Component
export default class Error extends ViewBase {
  @Prop({ type: Number, default: 0 }) code!: number
}
